import {Menu, Popconfirm} from "antd";
import {RightCircleFilled, UserOutlined} from '@ant-design/icons';
import {useApi} from "../provider/ApiProvider";
import {useHistory} from "react-router-dom";
const { SubMenu } = Menu;
export default function TopBar(){

    const {user, logout} = useApi();
    const history = useHistory();

    function onClick(){
        logout();
        history.push('/login');
    }

    return (
      <>
          <div className="logo">
              PANEL-XD
          </div>
          <Menu theme="light" mode="horizontal">
              <SubMenu key="sub1" icon={<UserOutlined/>} title={user?.firstName}>
                  <Menu.Item key="1" style={{padding: 0}}>
                      <Popconfirm
                          title="Cıkış yapılsın mı?"
                          onConfirm={() => {onClick()}}
                          onCancel={() => {
                              return;
                          }}
                          okText="Evet"
                          cancelText="Hayır"

                      >
                          <div style={{ margin: 0, width: '100%', paddingLeft: '5%'}}>Çıkış</div>
                      </Popconfirm>
                  </Menu.Item>

              </SubMenu>
          </Menu>
      </>
    )
}
